import React, { useEffect, useState } from "react";
import { useForm } from "../../../Hooks/UseForm";
import ButtonGeneric from "../../../components/Buttons/ButtonGeneric";
import InputGeneric from "../../../components/Inputs/InputGeneric";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../../components/Loading/loadingSpinner/Spinner";
import Modal from "../../../components/Modals/Modal";
import { UseContextApp } from "../../../Global/Context/appContext";
import BreadCrumbsGeneric from "../../../components/Nav/BreadCrumbsGeneric";
import SelectGeneric from "../../../components/Inputs/SelectGeneric";
import { validateDomiciliacion } from "../../../validations/formValidations";
import DomiciliacionController from "../../../controllers/DomiciliacionController";
import { formDomiciliacion, optionTipoDoc, optionPhone } from "../../../propsType/Domiciliacion";
import bbva from "../../../assets/bancos/newLogos/provincial.png";
import banesco from "../../../assets/bancos/newLogos/banesco-50.png";
import mercantil from "../../../assets/bancos/newLogos/mercantil-50.png";
import bancoVenezuela from "../../../assets/bancos/newLogos/bdv-50.png";
import otroBanco from "../../../assets/bancos/newLogos/otrobanco.png";

function DomiciliacionDebitoCta() {
    const [check, setCheck] = useState(false);
    const [activeModal, setActiveModal] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [{ user }] = UseContextApp();
    const [emailCliente, setEmailCliente] = useState(user?.datos?.email);
    const [nroCuenta, setNroCuenta] = useState(localStorage.getItem('nroCuenta'))
    const [ciudadCta, setCiudadCta] = useState(localStorage.getItem('ciudadCta'))
    const [descripDomBanco, setDescripDomBanco] = useState(localStorage.getItem('descripDomBanco'))
    const location = useLocation();
    const pathName = location.pathname;
    const { domiciliacion } = DomiciliacionController();
    const navigate = useNavigate();
    const [isCheckTerminos, setIsCheckTerminos] = useState(false);
    const handleOnTerminos = () => { setIsCheckTerminos(!isCheckTerminos); };
    const [logo, setLogo] = useState("")

    function filtro(e) {
        var tecla = e.key;
        if (['.', 'e', 'E', '-', ','].includes(tecla))
            e.preventDefault()
    };
    let monto = parseFloat(localStorage.getItem('deudaTotalVEF'))
    localStorage.setItem('deuda', monto);
    const errores = (errorType) => {
        setLoading(false);
        setActiveModal(true);
        switch (errorType) {
            case "Correo":
                setMessage("Ingresa el correo electrónico del titular bancario del instrumento de pago.");
                break;
            case "Terminos":
                setMessage("Debe aceptar los Términos y Condiciones.");
                break;
        };
    };
    const {
        form,
        errors,
        setForm,
        setErrors,
        handleChange,
        handleSubmit,
        handleBlur,
    } = useForm(
        formDomiciliacion,
        validateDomiciliacion,
        emailCliente,
        descripDomBanco
    );
    const closetModal = () => {
        setActiveModal(false);
        setMessage("");
    };

    const changeLogo = () => {
        switch (descripDomBanco) {
            case "BBVA": return bbva;
            case "BDV": return bancoVenezuela;
            case "Banesco": return banesco;
            case "Mercantil": return mercantil;
        }
    }

    const validateData = () => {
        switch (descripDomBanco) {
            case "BBVA": return form.swiftcuenta = "0108";
            case "BDV": return form.swiftcuenta = "0102";
            case "Banesco": return form.swiftcuenta = "0134";
            case "Mercantil": return form.swiftcuenta = "0105";
            default: return form.swiftcuenta = "";
        }
    };

    const volver = () => { navigate('/cuenta/domiciliacion/tipo-instrumento'); };

    const enviarDomiciliar = async () => {
        //Validar Campos
        let bError = "false";
        if ((emailCliente === "") && (emailCliente === undefined) && (form.email === "")) { errores("Correo"); bError = "true"; }
        else if (isCheckTerminos === false) { errores("Terminos"); bError = "true"; }
        if (bError === "false") {
          
            const result = handleSubmit();
         
            if (result === "ok") {
                let nroCuentaDomiciliar = form.swiftcuenta + form.cuentaBancaria;
                let newObjet = {
                    nombre: user?.datos?.nombreApellido,
                    tipoCliente: (user?.datos?.tipoCliente === "Hogar" ? "Residencial" : "Corporativo"),
                    docIdentidad: user?.datos?.docIdentificacion,
                    email: emailCliente,
                    tlfContacto: form.selectNumber + form.phone,
                    ciudad: user?.datos?.ciudad.split(',')[0],
                    cuenta: nroCuenta,
                    tipoDomiciliacion: "Cuenta Bancaria",
                    bancoCta: localStorage.getItem('descripDomBanco'),
                    bancoTDC: "",
                    titularBancario: user?.datos?.nombreApellido,
                    docIdentidadTitularBancario: user?.datos?.docIdentificacion,
                    nroCuentaDomiciliar: nroCuentaDomiciliar,
                    nroTarjeta: "",
                    fechaVencimiento: "",
                    tipoTarjeta: "",
                    cvv: "",
                };

                setLoading(true);
              
                let res = await domiciliacion(newObjet);
            
                if (res) {
                    switch (res?.status) {
                        case "0004":
                            localStorage.setItem('ticket', res?.ticketNumber);
                            localStorage.setItem('titular', newObjet.nombre);
                            localStorage.setItem('cuenta', newObjet.cuenta);
                            localStorage.setItem('mop', "Cuenta Bancaria");
                            localStorage.setItem('mopNro', newObjet.nroCuentaDomiciliar);
                            localStorage.setItem('titularMop', newObjet.titularBancario);
                            localStorage.setItem('deuda', monto)
                            navigate("/cuenta/domiciliacion/confirmation");
                            break;
                        default:
                            setCheck(false);
                            setLoading(false);
                            setActiveModal(true);
                            setMessage("Por favor chequea los datos bancarios he intenta más tarde.");
                            break;
                    }
                }
            }
        }

    };

    function classNames(...classes) {
        return classes.filter(Boolean).join(" ");
    }

    useEffect(() => {

    }, []);


    return (
        <div className=" bg-[#f3f4f6] ">
            <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
                {loading ?
                    (
                        <>
                            <div className="w-full h-screen flex justify-center items-center ">
                                <Spinner title={"Espere..."} />
                            </div>
                        </>
                    ) : (
                        <>

                            <div className="rounded-[10px] flex lg:w-full gap-5 px-4  flex-col">
                                <BreadCrumbsGeneric locations={pathName} />
                                <div className="bg-white rounded-[10px] w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                                    <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                                        <div className="ml-4 mt-4">
                                            <h3 className="text-2xl leading-6 font-medium text-gray-900">
                                                Domicilia el Pago de tus Servicios
                                            </h3>
                                            <p className="mt-1 text-sm text-gray-500">Completa la información y haz clic en domiciliar </p>
                                        </div>
                                    </div>
                                    <div className="bg-white rounded-[10px] w-full px-4 py-5  sm:px-1">

                                        <div className="h-full flex flex-col gap-5 justify-between lg:pr-[50px] ">
                                            <hr className="pt-[10px] mt-[10px]" />
                                            <div className="grid lg:gap-[32px] gap-6 lg:relative lg:top-[10px] ">
                                                <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10">
                                                    <div className="grid">
                                                        <div className="flex gap-[3px] items-center text-gray-900">
                                                            <p className=" text-sm font-medium  ">
                                                                Documento de Identidad
                                                            </p>
                                                        </div>

                                                        <div className="col-span-5">
                                                            <InputGeneric
                                                                disable={true}
                                                                placeholder={user?.datos?.docIdentificacion}
                                                                onChange={handleChange}
                                                                name={"nroDoc"}
                                                                value={form.nroDoc}
                                                                handleBlur={handleBlur}
                                                                errorText={errors.nroDoc}
                                                            />
                                                        </div>

                                                    </div>
                                                    <div className="grid">
                                                        <div className="flex gap-[3px] items-center text-gray-900">
                                                            <p className=" text-sm font-medium ">Nombre y Apellido</p>
                                                        </div>
                                                        <div className="col-span-5">
                                                            <InputGeneric
                                                                disable={true}
                                                                placeholder={user?.datos?.nombreApellido}
                                                                onChange={handleChange}
                                                                name={"name"}
                                                                value={form.name}
                                                                errorText={errors.name}
                                                                handleBlur={handleBlur}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="grid gap-3 lg:grid-cols-2 lg:gap-10">
                                                    <InputGeneric
                                                        title={"Correo Electrónico"}
                                                        name={"email"}
                                                        handleBlur={handleBlur}
                                                        onChange={e => setEmailCliente(e.target.value)}
                                                        errorText={errors.email}
                                                        value={emailCliente}
                                                    />
                                                    <div className="grid">
                                                        <div className="flex gap-[3px] items-center text-gray-900">
                                                            <p className="text-sm font-medium  ">Teléfono de Contacto</p>
                                                        </div>
                                                        <div className="grid !mt-1  grid-cols-7">
                                                            <div className="col-span-2">
                                                                <SelectGeneric
                                                                    onChange={handleChange}
                                                                    value={form.selectNumber || ""}
                                                                    name={"selectNumber"}
                                                                    onBlur={handleBlur}
                                                                    errors={errors.selectNumber}
                                                                    selectData={optionPhone}
                                                                />
                                                            </div>
                                                            <div className="col-span-5">
                                                                <InputGeneric
                                                                    name={"phone"}
                                                                    type={"number"}
                                                                    value={form.phone}
                                                                    onChange={handleChange}
                                                                    handleBlur={handleBlur}
                                                                    errorText={errors.phone}
                                                                    onKeyDown={(e) => filtro(e)}
                                                                    maxValue={7}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="grid gap-3 lg:grid-cols-2 lg:gap-10">
                                                    <InputGeneric
                                                        title={"Cuenta a Domiciliar"}
                                                        name={"cuentaDomiciliar"}
                                                        disable={true}
                                                        handleBlur={handleBlur}
                                                        onChange={handleChange}
                                                        errorText={errors.cuentaDomiciliar}
                                                        value={nroCuenta + " - " + ciudadCta}
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <p className="mt-1 text-sm text-gray-600">Ingresa los datos de la cuenta bancaria que deseas domiciliar.</p>
                                                <hr className="pt-[10px] mt-[10px]" />
                                                <div style={descripDomBanco !== "Otro Banco" ? { display: '' } : { display: 'none' }}>
                                                    <div className="h-full flex flex-col justify-between lg:pr-[50px] ">
                                                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                                                            <div className="w-full space-y-1">
                                                                <div className=" flex items-center gap-[3px] text-gray-900">
                                                                    <p className="text-sm font-medium">
                                                                        Número de Cuenta:
                                                                    </p>
                                                                    <img className=" w-[80px] " src={changeLogo()} alt="" />
                                                                </div>
                                                                <div className="grid !mt-1  grid-cols-7">
                                                                    <div className="col-span-2">
                                                                        <InputGeneric
                                                                            name={"swiftcuenta"}
                                                                            type={"text"}
                                                                            placeholder={validateData()}
                                                                            disable={true}
                                                                            onChange={validateData()}
                                                                            handleBlur={handleBlur}
                                                                            errorText={errors.swiftcuenta}
                                                                            value={form.swiftcuenta}
                                                                            maxValue={4}
                                                                        />
                                                                    </div>
                                                                    <div className="col-span-5">
                                                                        <InputGeneric
                                                                            name={"cuentaBancaria"}
                                                                            handleBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                            errorText={errors.cuentaBancaria}
                                                                            value={form.cuentaBancaria}
                                                                            onKeyDown={(e) => filtro(e)}
                                                                            type={"text"}
                                                                            maxValue={16}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={descripDomBanco === "Otro Banco" ? { display: '' } : { display: 'none' }}>
                                                    <div className="h-full flex flex-col justify-between lg:pr-[50px] ">
                                                        <div className=" grid gap-3 lg:grid-cols-2 lg:gap-10 place-items-end">
                                                            <div className="w-full space-y-1">
                                                                <div className=" flex items-center gap-[3px] text-gray-900">
                                                                    <p className="text-sm font-medium">
                                                                        Número de Cuenta:
                                                                    </p>
                                                                    <img className=" w-[80px] " src={otroBanco} alt="" />
                                                                </div>
                                                                <div className="grid !mt-1  grid-cols-7">
                                                                    <div className="col-span-5">
                                                                        <InputGeneric
                                                                            name={"ctaBancariaAll"}
                                                                            handleBlur={handleBlur}
                                                                            onChange={handleChange}
                                                                            errorText={errors.ctaBancariaAll}
                                                                            value={form.ctaBancariaAll}
                                                                            onKeyDown={(e) => filtro(e)}
                                                                            type={"text"}
                                                                            maxValue={20}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex gap-3 pt-3  flex-col items-center  ">
                                                <div className="flex items-start md:items-center gap-3">
                                                    <input
                                                        type={"checkbox"}
                                                        className="mt-[2px] md:m-0"
                                                        name={"form.terminos"}
                                                        checked={isCheckTerminos}
                                                        onChange={handleOnTerminos}
                                                        value={form.terminos} />
                                                    <label>
                                                        {" "}
                                                        <p className="text-[0.8rem] text-center text-[#798791]">
                                                            Acepto los{" "}
                                                            <a
                                                                target="_blank"
                                                                className="hover:text-black"
                                                                href="https://www.netuno.net.ve/cuenta/T%C3%A9rminos_Condiciones_Domicilio_Nacional.pdf"
                                                            >
                                                                {" "}
                                                                <strong>Términos y Condiciones </strong>{" "}
                                                            </a>{" "}
                                                        </p>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="w-full flex justify-between gap-[50%]">
                                                <div className="w-full">
                                                    <ButtonGeneric funtion={volver} text={"Volver"} />
                                                </div>
                                                <div className="w-full">
                                                    <ButtonGeneric funtion={enviarDomiciliar} text={"Domiciliar"} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
            </div>

            <Modal
                string={check ? "check" : "error"}
                message={message}
                active={activeModal}
                setActive={setActiveModal}
            >
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <div className="flex  flex-col gap-2 ">
                        <button
                            type="button"
                            onClick={(e) => check ? navigate = '/cuenta/pagos' : closetModal()}
                            className={` ${check ? "bg-green-500" : "bg-red-500"
                                } inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto`}
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    );

}
export default DomiciliacionDebitoCta;